import { UpdateMessageOrigin } from '@canvas/protocol-types';

export function isUndoRedo(origin: UpdateMessageOrigin) {
  return (origin & UpdateMessageOrigin.UndoRedo) === UpdateMessageOrigin.UndoRedo;
}

export function isCleanDocument(origin: UpdateMessageOrigin) {
  return (
    (origin & UpdateMessageOrigin.CleanDocument) === UpdateMessageOrigin.CleanDocument
  );
}
